import React, { useEffect, createElement } from 'react';
import { MarqueeBar } from './components/MarqueeBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { ProductPresentation } from './components/ProductPresentation';
import { PricingSection } from './components/PricingSection';
import { CountdownTimer } from './components/CountdownTimer';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { OfferRecap } from './components/OfferRecap';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { FooterSection } from './components/FooterSection';
export function App() {
  useEffect(() => {
    document.title = 'Keto Air Fryer | Recetas para Argentina';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)}; 
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1507139884086812');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const checkFbq = setInterval(() => {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'ViewContent', {
          content_name: 'Keto Air Fryer Recetario',
          content_category: 'Recetario Keto',
          content_type: 'product',
          currency: 'ARS',
          value: 9000
        });
        clearInterval(checkFbq);
      }
    }, 500);
    return () => clearInterval(checkFbq);
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-[#00A86B] selection:text-white" data-id="element-0">
      <MarqueeBar data-id="element-1" />

      <main className="pt-10" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <ProductPresentation data-id="element-5" />
        <PricingSection data-id="element-6" />
        <CountdownTimer data-id="element-7" />
        <BonusSection data-id="element-8" />
        <Testimonials data-id="element-9" />
        <OfferRecap data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <FooterSection data-id="element-14" />
    </div>;
}